export default __webpack_public_path__ + "734944195444a811532f45fffca6f28d.svg";